import React from 'react';
import { Field, Pill, slug } from './atoms';
import { VISA_GOAL, REMOTE_WORK, RFC, PROPERTY } from './constants';

const Step5Immigration = ({ form, setField }) => (
  <div data-testid="step-5">
    <div className="mb-5">
      <h1 className="text-xl sm:text-2xl font-light" data-testid="step5-headline">Immigration &amp; legal.</h1>
      <p className="text-sm mt-1 text-[#5A6B73]">Optional - skip if you'd rather move fast.</p>
    </div>

    <div className="space-y-4">
      <Field label="Visa goal" optional testId="field-visa">
        <div className="grid grid-cols-1 gap-2">
          {VISA_GOAL.map((v) => (
            <Pill key={v} active={form.visa_goal === v}
              onClick={() => setField('visa_goal', v)}
              testId={`onboarding-visa-${slug(v)}`}>
              {v}
            </Pill>
          ))}
        </div>
      </Field>

      <Field label="Plan to work remotely from Mexico?" optional testId="field-remote">
        <div className="grid grid-cols-3 gap-2">
          {REMOTE_WORK.map((r) => (
            <Pill key={r} small active={form.remote_work === r}
              onClick={() => setField('remote_work', r)}
              testId={`onboarding-remote-${slug(r)}`}>
              {r}
            </Pill>
          ))}
        </div>
      </Field>

      <Field label="Do you have a Mexican RFC / tax ID?" optional testId="field-rfc">
        <div className="grid grid-cols-3 gap-2">
          {RFC.map((r) => (
            <Pill key={r} small active={form.has_rfc === r}
              onClick={() => setField('has_rfc', r)}
              testId={`onboarding-rfc-${slug(r)}`}>
              {r}
            </Pill>
          ))}
        </div>
      </Field>

      <Field label="Own or plan to buy property in Mexico?" optional testId="field-property">
        <div className="grid grid-cols-3 gap-2">
          {PROPERTY.map((p) => (
            <Pill key={p} small active={form.property_intent === p}
              onClick={() => setField('property_intent', p)}
              testId={`onboarding-property-${slug(p)}`}>
              {p}
            </Pill>
          ))}
        </div>
      </Field>
    </div>
  </div>
);

export default Step5Immigration;
